import FroalaEditor from 'froala-editor';
import { froalaLangTypes, langTypes } from '../config/config';

// 語系的 Key 可以從 node_modules/froala-editor/js/languages/es.js 對照
export default function extendLang({ langCode, translate }) {
    // 'en' not has language variable need assign
    if (FroalaEditor.HasCoverLang) return;

    FroalaEditor.LANGUAGE[langCode] = FroalaEditor.LANGUAGE[langCode] || {
        direction: 'ltr',
        translation: {}
    };
    const langData =
        FroalaEditor.LANGUAGE[langCode].translation || FroalaEditor.LANGUAGE[langCode].translation;
    FroalaEditor.LANGUAGE[langCode].translation = {
        ...langData,
        // Toolbar 按鈕
        'Paragraph Format': translate({
            id: 'froala.style',
            defaultMessage: '樣式'
        }),
        'Font Family': translate({
            id: 'froala.font_family',
            defaultMessage: '字體'
        }),
        'Font Size': translate({
            id: 'froala.font_size',
            defaultMessage: '文字大小'
        }),
        Bold: translate({
            id: 'froala.bold',
            defaultMessage: '粗體'
        }),
        'Text Color': translate({
            id: 'froala.text_color',
            defaultMessage: '文字顏色'
        }),
        'Background Color': translate({
            id: 'froala.text_background',
            defaultMessage: '文字背景'
        }),
        Align: translate({
            id: 'froala.align',
            defaultMessage: '對齊'
        }),
        'Align Left': translate({
            id: 'froala.align_left',
            defaultMessage: '靠左對齊'
        }),
        'Align Center': translate({
            id: 'froala.align_center',
            defaultMessage: '置中對齊'
        }),
        'Align Right': translate({
            id: 'froala.align_right',
            defaultMessage: '靠右對齊'
        }),
        'Align Justify': translate({
            id: 'froala.align_justify',
            defaultMessage: '左右對齊'
        }),
        'More Text': translate({
            id: 'froala.more_text',
            defaultMessage: '文字設定'
        }),
        'Insert Link': translate({
            id: 'froala.link',
            defaultMessage: '連結'
        }),
        'Insert Table': translate({
            id: 'froala.table',
            defaultMessage: '表格'
        }),
        'Insert Image': translate({
            id: 'froala.image',
            defaultMessage: '圖片'
        }),
        button_InsertButton: translate({
            id: 'froala.custom_button',
            defaultMessage: '按鈕'
        }),
        div_InserButton: translate({
            id: 'froala.custom_div',
            defaultMessage: '內容區塊'
        }),
        'More Rich': translate({
            id: 'froala.more_rich',
            defaultMessage: '更多'
        }),
        Undo: translate({
            id: 'froala.undo',
            defaultMessage: '回復'
        }),
        'Code View': translate({
            id: 'froala.code_view',
            defaultMessage: '程式碼'
        }),
        'Upload Image': translate({
            id: 'froala.upload_image',
            defaultMessage: '上傳圖片'
        }),
        'By URL': translate({
            id: 'froala.by_url',
            defaultMessage: '網址上傳'
        }),
        'Drop image': translate({
            id: 'froala.drop_image',
            defaultMessage: '圖片拖曳'
        }),
        'or click': translate({
            id: 'froala.or_click',
            defaultMessage: '或點擊'
        }),
        'Quick Insert': translate({
            id: 'froala.quick_insert',
            defaultMessage: '快插'
        }),
        // Toolbar 文字設定階層按鈕
        Underline: translate({
            id: 'froala.underline',
            defaultMessage: '底線'
        }),
        Italic: translate({
            id: 'froala.italic',
            defaultMessage: '斜體'
        }),
        Strikethrough: translate({
            id: 'froala.strikethrough',
            defaultMessage: '刪除線'
        }),
        Subscript: translate({
            id: 'froala.subscript',
            defaultMessage: '下標'
        }),
        Superscript: translate({
            id: 'froala.superscript',
            defaultMessage: '上標'
        }),
        'Clear Formatting': translate({
            id: 'froala.format_clear',
            defaultMessage: '清除格式'
        }),
        'Ordered List': translate({
            id: 'froala.ordered_list',
            defaultMessage: '項目清單'
        }),
        Default: translate({
            id: 'froala.default',
            defaultMessage: '預設'
        }),
        'Lower Alpha': translate({
            id: 'froala.lower_alpha',
            defaultMessage: '小寫字母'
        }),
        'Lower Greek': translate({
            id: 'froala.lower_greek',
            defaultMessage: '小寫希臘字母'
        }),
        'Lower Roman': translate({
            id: 'froala.lower_roman',
            defaultMessage: '小寫羅馬數字'
        }),
        'Upper Alpha': translate({
            id: 'froala.upper_alpha',
            defaultMessage: '大寫字母'
        }),
        'Upper Roman': translate({
            id: 'froala.upper_roman',
            defaultMessage: '大寫羅馬數字'
        }),
        'Unordered List': translate({
            id: 'froala.unordered_list',
            defaultMessage: '符號清單'
        }),
        Circle: translate({
            id: 'froala.circle',
            defaultMessage: '圓圈'
        }),
        Disc: translate({
            id: 'froala.disc',
            defaultMessage: '實心原點'
        }),
        Square: translate({
            id: 'froala.square',
            defaultMessage: '方形'
        }),
        'Line Height': translate({
            id: 'froala.line_height',
            defaultMessage: '行高'
        }),
        Single: translate({
            id: 'froala.single',
            defaultMessage: '單行'
        }),
        Double: translate({
            id: 'froala.double',
            defaultMessage: '雙行'
        }),
        'Increase Indent': translate({
            id: 'froala.increase_indent',
            defaultMessage: '增加縮排'
        }),
        'Decrease Indent': translate({
            id: 'froala.decrease_indent',
            defaultMessage: '減少縮排'
        }),
        Quote: translate({
            id: 'froala.quote',
            defaultMessage: '引用'
        }),
        // Toolbar 更多按鈕階層按鈕
        'Insert Horizontal Line': translate({
            id: 'froala.insert_horizontal_line',
            defaultMessage: '分隔線'
        }),
        'Special Characters': translate({
            id: 'froala.special_characters',
            defaultMessage: '特殊符號'
        }),
        Emoticons: translate({
            id: 'froala.emotions',
            defaultMessage: '表情符號'
        }),
        // 客製化按鈕 - Pop Up
        button_text: translate({
            id: 'froala.text',
            defaultMessage: '文字'
        }),
        button_href: translate({
            id: 'froala.url',
            defaultMessage: 'URL'
        }),
        blank_link: translate({
            id: 'froala.open_blank_link',
            defaultMessage: '於新視窗開啟連結'
        }),
        // 客製化按鈕 - Second Toolbar
        button_textColor: translate({
            id: 'froala.text_color',
            defaultMessage: '文字顏色'
        }),
        button_bgColor: translate({
            id: 'froala.background_color',
            defaultMessage: '背景顏色'
        }),
        button_EditButton: translate({
            id: 'froala.edit',
            defaultMessage: '編輯按鈕'
        }),
        // 客製化按鈕 - 樣式下拉選單
        button_style_plain: translate({
            id: 'froala.pure_text',
            defaultMessage: '純文字'
        }),
        button_style_solid: translate({
            id: 'froala.solid',
            defaultMessage: '實心'
        }),
        button_style_hollow: translate({
            id: 'froala.hollow',
            defaultMessage: '空心'
        }),
        // Second Toolbar 公用按鈕
        border_style: translate({
            id: 'froala.border_style',
            defaultMessage: '邊框'
        }),
        padding: translate({
            id: 'froala.padding',
            defaultMessage: '間距'
        }),
        // Pop Up 公用文字
        'HEX Color': translate({
            id: 'froala.hex_color',
            defaultMessage: '十六進制顏色'
        }),
        opacity: translate({
            id: 'froala.opacity',
            defaultMessage: '透明度'
        }),
        // 公用
        OK: translate({
            id: 'froala.ok',
            defaultMessage: 'OK'
        }),
        Insert: translate({
            id: 'froala.insert',
            defaultMessage: '插入'
        }),
        'Border Width': translate({
            id: 'froala.border_width',
            defaultMessage: '邊框粗細'
        }),
        // 客製化內容區塊 - 樣式下拉選單
        div_style_solid: translate({
            id: 'froala.solid_border',
            defaultMessage: '實線邊框'
        }),
        div_style_dashed: translate({
            id: 'froala.dash_border',
            defaultMessage: '虛線邊框'
        }),
        pure_color: translate({
            id: 'froala.pure_color',
            defaultMessage: '純色'
        }),
        // 表格設定
        'Table Footer': translate({
            id: 'froala.table_footer',
            defaultMessage: '表尾'
        }),
        'Table Header': translate({
            id: 'froala.table_header',
            defaultMessage: '表頭'
        }),
        'Remove Table': translate({
            id: 'froala.remove_table',
            defaultMessage: '移除表格'
        }),
        Row: translate({
            id: 'froala.row',
            defaultMessage: '列'
        }),
        'Insert row above': translate({
            id: 'froala.insert_row_above',
            defaultMessage: '插入上方列'
        }),
        'Insert row below': translate({
            id: 'froala.insert_row_below',
            defaultMessage: '插入下方列'
        }),
        'Delete row': translate({
            id: 'froala.delete_row',
            defaultMessage: '刪除列'
        }),
        Column: translate({
            id: 'froala.column',
            defaultMessage: '欄'
        }),
        'Insert column before': translate({
            id: 'froala.insert_column_before',
            defaultMessage: '插入左方欄'
        }),
        'Insert column after': translate({
            id: 'froala.insert_column_after',
            defaultMessage: '插入右方欄'
        }),
        'Delete column': translate({
            id: 'froala.delete_column',
            defaultMessage: '刪除欄'
        }),
        'Table Style': translate({
            id: 'froala.table_style',
            defaultMessage: '表格樣式'
        }),
        Cell: translate({
            id: 'froala.cell',
            defaultMessage: '單元格'
        }),
        'Merge cells': translate({
            id: 'froala.merge_cells',
            defaultMessage: '合併單元格'
        }),
        'Horizontal split': translate({
            id: 'froala.horizontal_split',
            defaultMessage: '水平分割'
        }),
        'Vertical split': translate({
            id: 'froala.vertical_split',
            defaultMessage: '垂直分割'
        }),
        'Cell Background': translate({
            id: 'froala.cell_background',
            defaultMessage: '單元格背景'
        }),
        'Vertical Align': translate({
            id: 'froala.vertical_align',
            defaultMessage: '垂直對齊'
        }),
        Top: translate({
            id: 'froala.top',
            defaultMessage: '上方'
        }),
        Middle: translate({
            id: 'froala.middle',
            defaultMessage: '中間'
        }),
        Bottom: translate({
            id: 'froala.bottom',
            defaultMessage: '底部'
        }),
        'Horizontal Align': translate({
            id: 'froala.horizontal_align',
            defaultMessage: '水平對齊'
        }),
        'Cell Style': translate({
            id: 'froala.cell_style',
            defaultMessage: '單元格樣式'
        }),
        Thick: translate({
            id: 'froala.table_thick',
            defaultMessage: '粗框'
        }),
        Highlighted: translate({
            id: 'froala.highlight',
            defaultMessage: '高亮'
        }),
        // 連結 - Second Toolbar
        'Open Link': translate({
            id: 'froala.open_link',
            defaultMessage: '開啟連結'
        }),
        'Edit Link': translate({
            id: 'froala.edit_link',
            defaultMessage: '編輯連結'
        }),
        Unlink: translate({
            id: 'froala.remove_link',
            defaultMessage: '移除連結'
        }),
        // Padding Popup
        'Padding Horizontal': translate({
            id: 'froala.padding_horizontal',
            defaultMessage: '左右間距'
        }),
        'Padding Vertical': translate({
            id: 'froala.padding_vertical',
            defaultMessage: '上下間距'
        }),
        'Border Radius': translate({
            id: 'froala.border_radius',
            defaultMessage: '圓角'
        })
    };
    FroalaEditor.HasCoverLang = true;
}

export const getLangCode = locale => {
    switch (locale) {
        case langTypes.JA_JP:
            return froalaLangTypes.JA_JP;
        case langTypes.ZH_TW:
            return froalaLangTypes.ZH_TW;
        case langTypes.EN_US:
        default:
            return froalaLangTypes.EN_US;
    }
};
